import React from 'react'
import TermosDeUso from './../../components/TermosDeUso'
import Panel from './../../components/Panel'

const TermosDeUsoRoute = () => {
  return (
    <Panel
      featurePanel
      mainPanel={<TermosDeUso className='main-panel__form' />}
    />
  )
}

export default TermosDeUsoRoute



// WEBPACK FOOTER //
// ./src/routes/TermosDeUso/index.js